import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import BannerCustom from "components/Banners/BannerCustom";
import useAppDispatch from "hooks/useAppDispatch";
import sandboxIcon from "img/illustrations/general/sandbox.svg";
import { switchBackFromSandbox } from "containers/ProductSettingsPage/Sandbox";
import "./SandboxAccess.sass";

export default function SandboxAccessDenied({ hidden = false }) {
  const { t } = useTranslation("productSettings");
  const dispatch = useAppDispatch();
  const [error, setError] = useState("");

  const switchBack = async () => {
    setError("");
    try {
      await dispatch(switchBackFromSandbox());
      window.location.reload();
    } catch (switchError) {
      setError(switchError?.message || String(switchError || t("sharedUi.common.error", { ns: "translation" })));
    }
  };

  return (
    <div className="SandboxAccessDenied">
      <img className="SandboxAccessDenied__icon" src={sandboxIcon} alt="" />
      <h2>
        {t("sandbox.access.title", {
          defaultValue: "This feature is not available in Sandbox",
        })}
      </h2>
      <p>
        {hidden
          ? t("sandbox.access.noPermission", {
              defaultValue:
                "You don't have permission to use this feature in Sandbox.",
            })
          : t("sandbox.access.disabledDescription", {
              defaultValue:
                "Switch back to your live company to access this feature.",
            })}
      </p>
      {error ? (
        <div className="SandboxAccessDenied__error">
          <BannerCustom status="critical" message={error} />
        </div>
      ) : null}
      <Button variant="primary" onClick={switchBack}>
        {t("sandbox.navigation.switchBack", {
          defaultValue: "Switch back to live company",
        })}
      </Button>
    </div>
  );
}

SandboxAccessDenied.propTypes = {
  hidden: PropTypes.bool,
};
